export type ContainerWindowMeta = {
  windowId?: string
  title?: string
}

// Reads the __CONTAINER__ global that the parent injects into a windowed
// app's iframe (see Window.tsx's useInjectIframeScript call). Injection
// happens on the iframe's `load` event — after the app's own bundle has
// started executing — so this can be undefined for a brief window right
// after mount. Read it lazily at the point of use, not at effect-setup time.
export function getContainerWindowMeta(): ContainerWindowMeta | undefined {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const container = (window as any)?.__CONTAINER__
  if (!container) return undefined
  return {
    windowId: typeof container.windowId === 'string' ? container.windowId : undefined,
    title: typeof container.title === 'string' ? container.title : undefined
  }
}
